import './App.css';
import React, { useEffect } from 'react';
import Router from './Router';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getStorage, removeAllLocalStorage, setStorage } from './utils';
import constant from './constant';

function App() {

  useEffect(() => {
    const version = getStorage('v');

    if (version !== constant.version.web) {
      removeAllLocalStorage();
      setStorage('v', constant.version.web);

      // Correct way to redirect
      window.location.href = constant.component.login.url;
    }
  }, []);

  return (
    <React.Fragment>
      {/* <button onClick={() => toast.success("Custom font applied!")}>Show Toast</button> */}
      <ToastContainer />
      <Router />
    </React.Fragment>
  );
}

export default App;
